import ReactGA from "react-ga4";

import { Level } from "../utils/isValidLevel";

// This custom hook is currently disabled, awaiting future implementation to send events to Google Analytics.
// For now, we're focusing on page_view events for better data comparison between old and new game design.

type GA4EventProps = {
  level?: number | string;
};

export enum GA4Event {
  gameStarted = "game_started",
  gameFinished = "game_finished",
  gameWon = "game_won",
  scoreShared = "score_shared",
}

export function sendGoogleAnalyticsEvent(name: GA4Event, levelName: Level) {
  if (!ReactGA.isInitialized) {
    console.error("Google Analytics is not initialized");
    return;
  }

  const eventProps: GA4EventProps = { level: levelName };

  console.log(`Sending GA4 event: ${name}`, eventProps);
  ReactGA.event(name, eventProps);
}

export default function useGoogleAnalyticsEvent(
  name: GA4Event,
  levelName: Level,
) {
  sendGoogleAnalyticsEvent(name, levelName);
}
